import _t from 'i18n!nls/author-partner';

export const PartnerTypeValues = {
  UNIVERSITY: 'UNIVERSITY',
  INDUSTRY: 'INDUSTRY',
  PRIVATE_AUTHORING: 'PRIVATE_AUTHORING',
} as const;

export type PartnerTypeValuesType = (typeof PartnerTypeValues)[keyof typeof PartnerTypeValues];

export const PartnerTypeOptions: PartnerTypeValuesType[] = [
  PartnerTypeValues.UNIVERSITY,
  PartnerTypeValues.INDUSTRY,
  PartnerTypeValues.PRIVATE_AUTHORING,
];

export const getPartnerTypeLabel = (value: PartnerTypeValuesType) => {
  switch (value) {
    case 'UNIVERSITY':
      return _t('University');
    case 'INDUSTRY':
      return _t('Industry');
    case 'PRIVATE_AUTHORING':
      return _t('Private Authoring');
    default:
      return '';
  }
};
